export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/ms_sql.2a553fe.svg";